module.exports = __webpack_public_path__ + "static/media/wix-logo.a683e684.svg";